import { render, staticRenderFns } from "./EmptyNode.vue?vue&type=template&id=4306d06e&scoped=true"
import script from "./EmptyNode.vue?vue&type=script&lang=js"
export * from "./EmptyNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4306d06e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4306d06e')) {
      api.createRecord('4306d06e', component.options)
    } else {
      api.reload('4306d06e', component.options)
    }
    module.hot.accept("./EmptyNode.vue?vue&type=template&id=4306d06e&scoped=true", function () {
      api.rerender('4306d06e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/common/process/nodes/EmptyNode.vue"
export default component.exports